import React, { Component } from 'react'

export default class EmbroideryServicesType extends Component {
    render() {
        return (
          
      <section className="pricing-area pt-70 pb-70">
      <div className="container">
        <div className="col-12">
          <div className="services-details-text">
            <h3>Left breast digitization</h3>
            <p>We offer high quality left breast digitization for shirts, jackets, t-shirts. Ergo, the designs are given in where a short period of time, just place your order to enjoy the service.</p>
            <h3>Left chest digitization</h3>	
            <p>We are specialized as well as awarded in logo and small letter digitizing. Left chest digitization is mostly used to advertise one’s brand. Ergo, choose our service to have the best results.</p>
            <h3>Pocket digitizing</h3>	
            <p>This is one of the latest trends in the field of digitizing and we are having so many experts who have good knowledge and experience about different sorts of logos.</p> 							
            <h3>Cap digitizing</h3>	
            <p>If you are finding service for cap digitizing, then you are at the right place. We offer the best cap digitization in a very short period of time. Try our services and let us know if you liked our offerings or not.</p> 
            <h3>Jacket back digitizing</h3>	
            <p>Jacket back digitizing is also offered by our company. People can easily get league names or any other kind of artwork on back of jackets.</p>
            <h3>3D puff digitizing</h3>	
            <p>We are having 10+Wilcom machines with 20+ house experts and all of them are having a good sense of knowledge about 3D puff digitizing as well. Give us an opportunity to work for you, then you will get you to know more about our services.</p>
            <h3>Logo digitizing</h3>	
            <p>Logo digitization is also a service offered by our company. Give the image of the logo to us and we will convert it into machine ready files in just a short time interval.</p>
            <h3>Custom digitizing</h3>	
            <p>We are having years of experience in this field and this is the only thing that gives our customers 100% satisfaction. </p>
            <h3>Patch digitizing</h3>	
            <p>Patch digitizing is one of the best forms in the field of embroidery digitization. Ergo, we provide patch digitizing in a very short period of time at very affordable prices.</p>
            <h3>Applique digitizing</h3>	
            <p>If you are thinking to add applique to your designs, then you should choose us because adding applique to designs is fun and time rewarding. Ergo, the applique added to designs is perfectly fit and affordable in prices.</p>
            <h3>Letter/Flont digitizing</h3>	
            <p>Letter and Flont digitizing offered by our company are very much affordable and cheap in price. Ergo, this is one of the best embroidery digitizing services offered by us. Try our service and let us know if you liked our work or not.</p>
          </div>
        </div>
      </div>
    </section>
        )
    }
}
